import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addHelpAndFeedback,
  deleteHelpAndFeedback,
  getHelpAndFeedback,
  updateHelpAndFeedback,
} from "store/services/dataManagement/helpAndFeedback";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";

export const GetAllHelpAndFeedbackAction = createAsyncThunk(
  "helpAndFeedback/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getHelpAndFeedback(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  },
);

export const DeleteHelpAndFeedbackAction = createAsyncThunk(
  "helpAndFeedback/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, onError, ...rest } = payload;
      const res = await deleteHelpAndFeedback(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        const responce = await getHelpAndFeedback(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  },
);

export const UpdateHelpAndFeedbackAction = createAsyncThunk(
  "helpAndFeedback/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateHelpAndFeedback(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

export const AddHelpAndFeedbackAction = createAsyncThunk(
  "helpAndFeedback/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;
    try {
      // if any async operation need to be done on response data, do it here,
      // then full fill data
      const res = await addHelpAndFeedback(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());
        const responce = await getHelpAndFeedback(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) {
        onError();
      }
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);
